import { render, staticRenderFns } from "./TagViewsDialog.vue?vue&type=template&id=4e22374e"
import script from "./TagViewsDialog.vue?vue&type=script&lang=js"
export * from "./TagViewsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports